import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Pricing from "../components/Pricing";
import Documents from "../components/Documents";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function HomePage({ scrollTo }) {
  useEffect(() => {
    if (!scrollTo || scrollTo === "hero") return;
    // Wait for the page to render then scroll to the target section
    const timer = setTimeout(() => {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => clearTimeout(timer);
  }, [scrollTo]);

  return (
    <div className="min-h-screen bg-brand-cream font-sans" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Pricing />
        <Documents />
        <Gallery />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
